/**
 * 来源单据 mixin：封装来源单据探测、来源类型识别和详情弹窗路由。
 */
export default {
  methods: {
    /**
     * 判断普通来源单据探测所需的订单号、物料号、公司号是否齐全。
     */
    hasRequiredSourceParams: function (row) {
      row = row || {}
      return !!(row.ORDNO && row.MATNO && row.CORPID)
    },
    /**
     * 按来源类型判断探测参数是否齐全，BOM 只依赖物料和公司。
     */
    hasRequiredSourceParamsForRef: function (row, refType, refTypeId) {
      row = row || {}
      if (this.isTreeBomSource(refType, refTypeId)) return !!(row.MATNO && row.CORPID)
      if (this.isPrdChkRptSource(refType, refTypeId)) return !!(row.ORDNO && row.MATNO && row.CORPID)
      if (this.isQcPrdSource(refType, refTypeId)) return !!((row.ORDNO || row.IDNO || row.REFIDNO) && row.CORPID)
      if (this.isIncomingQaSource(refType, refTypeId)) return !!((row.ORDNO || row.IDNO || row.REFIDNO) && row.CORPID)
      if (this.isIncomingStkInSource(refType, refTypeId)) return !!((row.ORDNO || row.IDNO || row.REFIDNO) && row.CORPID)
      if (this.isPoSource(refType, refTypeId)) return !!((row.ORDNO || row.IDNO || row.REFIDNO) && (row.ORD_IDSEQ || row.ORDSEQ || row.IDSEQ) && (row.CORPID || this.vCorpid))
      if (this.isMaterialPlanSource(refType, refTypeId)) return !!((row.ORDNO || row.IDNO || row.REFIDNO) && (row.ORD_IDSEQ || row.ORDSEQ || row.IDSEQ) && (row.CORPID || this.vCorpid))
      return this.hasRequiredSourceParams(row)
    },
    /**
     * 转义来源单据查询条件中的单引号。
     */
    escapeSourceQueryValue: function (value) {
      return String(value === undefined || value === null ? '' : value).trim().replace(/'/g, "''")
    },
    /**
     * 转义并转小写，供 lower(...) 查询条件使用。
     */
    escapeLowerSourceQueryValue: function (value) {
      return this.escapeSourceQueryValue(value).toLowerCase()
    },
    /**
     * 根据来源类型构造探测查询 payload。
     */
    buildSourceProbePayload: function (row, refType, refTypeId) {
      row = row || {}
      var rawOrdno = row.ORDNO || row.IDNO || row.REFIDNO
      var ordno = this.escapeSourceQueryValue(rawOrdno)
      var matno = this.escapeSourceQueryValue(row.MATNO)
      var lowerOrdno = this.escapeLowerSourceQueryValue(rawOrdno)
      var lowerMatno = this.escapeLowerSourceQueryValue(row.MATNO)
      var ordseq = row.ORD_IDSEQ || row.ORDSEQ || row.IDSEQ
      var corpid = row.CORPID || this.vCorpid || ''
      if (this.isTreeBomSource(refType, refTypeId)) {
        return {
          sourceKind: 'treeBom',
          p_table: 'V_TREE_BOM',
          p_cond: " and corpid='" + this.escapeSourceQueryValue(corpid) + "'",
          p_value: row.MATNO
        }
      }
      if (this.isArCheckSource(refType, refTypeId)) {
        return { p_table: 'V_AR_CHKDTL_QRY', p_key: '', p_value: '', p_key2: 'corpid', p_value2: corpid, p_key3: '', p_value3: '', p_cond: " and IDNO like '%%' and REFORDNO like '%" + ordno + "%' and MATNO like '%" + matno + "%' and PAYIDNO is null" }
      }
      if (this.isPoSource(refType, refTypeId)) {
        return { p_table: 'V_po_reqdtl', p_key: 'ordseq', p_value: ordseq, p_key2: 'corpid', p_value2: corpid, p_key3: '', p_value3: '', p_cond: '' }
      }
      if (this.isOrderAuditSource(refType, refTypeId)) {
        return { p_table: 'v_ORD_AUDIT', p_key: '', p_value: '', p_key2: 'CORPID', p_value2: corpid, p_key3: '', p_value3: '', p_cond: " and lower(MATNO) like '%" + lowerMatno + "%' and lower(ORDNO) like '%" + lowerOrdno + "%'" }
      }
      if (this.isPcPickSource(refType, refTypeId)) {
        return { p_table: 'V_PC_PICKDTL_QRY', p_key: '', p_value: '', p_key2: 'corpid', p_value2: corpid, p_key3: '', p_value3: '', p_cond: " and IDNO like '%%' and ORDNO like '%" + ordno + "%' and MATNO like '%" + matno + "%' and isstk ='N'" }
      }
      if (this.isQcPrdSource(refType, refTypeId)) {
        return { p_table: 'V_QC_CHK', p_key: '', p_value: '', p_key2: 'CORPID', p_value2: corpid, p_key3: '', p_value3: '', p_cond: " and IDNO like '%%' and ORDNO like '%" + ordno + "%'" }
      }
      if (this.isPrdChkRptSource(refType, refTypeId)) {
        return { p_table: 'v_QC_PRD', p_key: '', p_value: '', p_key2: 'CORPID', p_value2: corpid, p_key3: '', p_value3: '', p_cond: " and ORDNO like '%" + this.escapeSourceQueryValue(row.ORDNO) + "%' and PRDNO like '%" + this.escapeSourceQueryValue(row.MATNO) + "%'" }
      }
      if (this.isSaleReceiveSource(refType, refTypeId)) {
        return { p_table: 'V_ORD_PAYDTL_QRY', p_key: '', p_value: '', p_key2: 'corpid', p_value2: corpid, p_key3: '', p_value3: '', p_cond: " and IDNO like '%%' and REFORDNO like '%" + ordno + "%' and MATNO like '%" + matno + "%'" }
      }
      if (this.isSaleOutSource(refType, refTypeId)) {
        return { p_table: 'V_IC_STK_SALEOUT', p_key: 'IDTY', p_value: 'SALEOUT', p_key2: 'CORPID', p_value2: corpid, p_key3: '', p_value3: '', p_cond: " and DTL_IDNO like '%" + ordno + "%' and DTL_MATNO like '%" + matno + "%' and IDNO like '%%'" }
      }
      if (this.isPrdInSource(refType, refTypeId)) {
        return { p_table: 'V_IC_PRDIN_QRY', p_key: 'IDTY', p_value: 'PRDIN', p_key2: 'CORPID', p_value2: corpid, p_key3: '', p_value3: '', p_cond: " and lower(DTL_IDNO) like '%" + lowerOrdno + "%' and lower(DTL_MATNO) like '%" + lowerMatno + "%' and IDNO like '%%'" }
      }
      if (this.isPrdOutSource(refType, refTypeId)) {
        return { p_table: 'V_IC_STKDTL_QRY', p_key: 'IDTY', p_value: 'PRDOUT', p_key2: 'corpid', p_value2: corpid, p_key3: '', p_value3: '', p_cond: " and IDNO like '%%' and ORDNO like '%" + ordno + "%' and ORDMATNO like '%" + matno + "%'" }
      }
      if (this.isIncomingQaSource(refType, refTypeId)) {
        return { p_table: 'V_IC_STK_QA', p_key: 'corpid', p_value: corpid, p_key2: 'IDTY', p_value2: 'QACHK', p_key3: '', p_value3: '', p_cond: " and IDNO like '%%' and lower(ORDNO) like '%" + lowerOrdno + "%'" }
      }
      if (this.isIncomingStkInSource(refType, refTypeId)) {
        return { p_table: 'V_IC_STK_POIN', p_key: 'IDTY', p_value: 'POIN', p_key2: 'CORPID', p_value2: corpid, p_key3: '', p_value3: '', p_cond: " and IDNO like '%%' and ORDNO like '%" + ordno + "%'" }
      }
      if (this.isMaterialPlanSource(refType, refTypeId)) {
        return { p_table: 'V_po_reqdtl', p_key: 'ordseq', p_value: ordseq, p_key2: 'corpid', p_value2: corpid, p_key3: '', p_value3: '', p_cond: '' }
      }
      return null
    },
    /**
     * 执行来源单据探测查询，BOM 来源走递归接口。
     */
    loadSourceProbeRows: function (payload) {
      if (!payload) return Promise.resolve([])
      if (payload.sourceKind === 'treeBom') return this.loadTreeBomProbeRows(payload)
      return this.loadTableRows(payload.p_table, payload.p_key, payload.p_value, payload.p_key2, payload.p_value2, payload.p_key3, payload.p_value3, payload.p_cond)
    },
    /**
     * 调用树状 BOM 递归接口探测是否存在 BOM 数据。
     */
    loadTreeBomProbeRows: function (payload) {
      return this.$axios({
        method: 'post',
        url: this.authUrl('xuper_auth/getLoopData'),
        data: {
          p_table: payload.p_table,
          p_cond: payload.p_cond,
          p_value: payload.p_value
        }
      }).then(function (res) {
        if (res && res.code === '200') return this.normalizeRows(res && res.result)
        return []
      }.bind(this))
    },
    /**
     * 并发探测节点的所有来源单据，任一来源命中则视为进行中。
     */
    probeNodeSourceStatus: function (row) {
      if (!this.hasRefDoc(row)) return Promise.resolve('未开始')
      var refTypeList = String(row.REFIDTY || '').split(',').map(function (item) { return item.trim() }).filter(function (item) { return item })
      var refTypeIdList = String(row.REFIDTYNM || '').split(',').map(function (item) { return item.trim() }).filter(function (item) { return item })
      var payloads = refTypeList.map(function (refType, index) {
        if (!this.hasRequiredSourceParamsForRef(row, refType, refTypeIdList[index] || '')) return null
        return this.buildSourceProbePayload(row, refType, refTypeIdList[index] || '')
      }.bind(this)).filter(function (item) { return item })
      if (!payloads.length) return Promise.resolve('未开始')
      return new Promise(function (resolve) {
        var pending = payloads.length
        var settled = false
        // 首个命中或全部完成后结束，防止较慢接口覆盖已命中的状态。
        var finish = function (status) {
          if (settled) return
          settled = true
          clearTimeout(timer)
          resolve(status)
        }
        var timer = setTimeout(function () {
          finish('未开始')
        }, 15000)
        payloads.forEach(function (payload) {
          this.loadSourceProbeRows(payload).then(function (rows) {
            if (settled) return
            if (rows && rows.length) {
              finish('进行中')
              return
            }
            pending -= 1
            if (pending <= 0) finish('未开始')
          }).catch(function () {
            if (settled) return
            pending -= 1
            if (pending <= 0) finish('未开始')
          })
        }.bind(this))
      }.bind(this))
    },
    /**
     * 处理节点卡片上的来源单据标签点击。
     */
    handleRefidtyClick: function (tag, data, index) {
      if (!this.hasSourceFormPermission(tag, data, index)) {
        this.handleSourcePermissionDenied()
        return
      }
      this.openSourceDialog(this.getRefNodeFromTag(tag, data, index))
    },
    /**
     * 从来源单据标签和节点数据中提取弹窗需要的单据节点信息。
     */
    getRefNodeFromTag: function (tag, data, index) {
      data = data || {}
      var refTypeList = String(data.REFIDTY || '').split(',').map(function (item) { return item.trim() }).filter(function (item) { return item })
      var refTypeIdList = String(data.REFIDTYNM || '').split(',').map(function (item) { return item.trim() }).filter(function (item) { return item })
      var refNoList = String(data.REFIDNO || '').split(',').map(function (item) { return item.trim() }).filter(function (item) { return item })
      var idx = index || 0
      return {
        refidty: tag || refTypeList[idx] || '',
        refidtynm: refTypeIdList[idx] || '',
        refidno: refNoList[idx] || data.REFIDNO || '',
        sourceOrderRow: Object.assign({}, this.effectiveOrderRow || {}),
        nodeData: data
      }
    },
    /**
     * 判断是否为采购申请/采购订单来源。
     */
    isPoSource: function (refType, refTypeId) {
      var typeText = String(refType || '').trim()
      var typeIdText = String(refTypeId || '').trim()
      if (typeText === '采购订单') return true
      if (typeText && !/^\d+$/.test(typeText)) return false
      return typeIdText === '228814' || typeText === '228814'
    },
    /**
     * 判断是否为订单评审来源。
     */
    isOrderAuditSource: function (refType, refTypeId) {
      var typeText = String(refType || '').trim()
      var typeIdText = String(refTypeId || '').trim()
      if (typeText === '订单评审表') return true
      if (typeText && !/^\d+$/.test(typeText)) return false
      return typeIdText === '228815' || typeText === '228815'
    },
    /**
     * 判断是否为生产投料/领料来源。
     */
    isPcPickSource: function (refType) {
      var typeText = String(refType || '').trim()
      return typeText === '生产任务单' || typeText === '生产投料单'
    },
    /**
     * 判断是否为制程巡检来源。
     */
    isQcPrdSource: function (refType, refTypeId) {
      var typeText = String(refType || '').trim()
      var typeIdText = String(refTypeId || '').trim()
      if (typeText === '制程巡检记录') return true
      if (typeIdText === '412735' || typeText === '412735') return true
      return false
    },
    /**
     * 判断是否为成品检验报告来源。
     */
    isPrdChkRptSource: function (refType, refTypeId) {
      var typeText = String(refType || '').trim()
      var typeIdText = String(refTypeId || '').trim()
      if (typeText === '成品检验报告') return true
      if (typeIdText === '412736' || typeText === '412736') return true
      return false
    },
    /**
     * 判断是否为销售应收来源。
     */
    isSaleReceiveSource: function (refType) {
      var typeText = String(refType || '').trim()
      return typeText === '销售应收单'
    },
    /**
     * 判断是否为成品出库来源。
     */
    isSaleOutSource: function (refType, refTypeId) {
      var typeText = String(refType || '').trim()
      var typeIdText = String(refTypeId || '').trim()
      if (typeText === '成品出库单' || typeText.toUpperCase() === 'SALEOUT') return true
      if (typeIdText === '成品出库单' || typeIdText.toUpperCase() === 'SALEOUT') return true
      return false
    },
    /**
     * 判断是否为成品入库来源。
     */
    isPrdInSource: function (refType, refTypeId) {
      var typeText = String(refType || '').trim()
      var typeIdText = String(refTypeId || '').trim()
      if (typeText === '成品入库单' || typeText.toUpperCase() === 'PRDIN') return true
      if (typeIdText === '成品入库单' || typeIdText.toUpperCase() === 'PRDIN') return true
      return false
    },
    /**
     * 判断是否为应收对账来源。
     */
    isArCheckSource: function (refType) {
      var typeText = String(refType || '').trim()
      return typeText === '应收对账单'
    },
    /**
     * 判断是否为生产出库来源。
     */
    isPrdOutSource: function (refType, refTypeId) {
      var typeText = String(refType || '').trim()
      var typeIdText = String(refTypeId || '').trim()
      if (typeText.indexOf('领料出库') > -1 || typeText.toUpperCase() === 'PRDOUT') return true
      if (typeText && !/^\d+$/.test(typeText)) return false
      return typeIdText.toUpperCase() === 'PRDOUT' || typeIdText === '17442' || typeText === '17442'
    },
    /**
     * 判断是否为来料质检来源。
     */
    isIncomingQaSource: function (refType, refTypeId) {
      var typeText = String(refType || '').trim()
      var typeIdText = String(refTypeId || '').trim()
      if (typeText === '来料质检单' || typeText.toUpperCase() === 'QACHK') return true
      if (typeIdText === '来料质检单' || typeIdText.toUpperCase() === 'QACHK') return true
      return false
    },
    /**
     * 判断是否为质检入库来源。
     */
    isIncomingStkInSource: function (refType, refTypeId) {
      var typeText = String(refType || '').trim()
      var typeIdText = String(refTypeId || '').trim()
      if (typeText === '质检入库单' || typeText.toUpperCase() === 'POIN') return true
      if (typeIdText === '质检入库单' || typeIdText.toUpperCase() === 'POIN') return true
      return false
    },
    /**
     * 判断是否为物料计划来源。
     */
    isMaterialPlanSource: function (refType, refTypeId) {
      var typeText = String(refType || '').trim()
      var typeIdText = String(refTypeId || '').trim()
      if (typeText === '物料计划') return true
      if (typeIdText === '物料计划') return true
      return false
    },
    /**
     * 判断是否为树状 BOM 来源。
     */
    isTreeBomSource: function (refType, refTypeId) {
      var typeText = String(refType || '').trim()
      var typeIdText = String(refTypeId || '').trim()
      if (typeText === '树状BOM表' || typeText === '树状BOM') return true
      if (typeIdText === '树状BOM表' || typeIdText === '树状BOM') return true
      return false
    },
    /**
     * 根据来源类型打开对应详情弹窗。
     */
    openSourceDialog: function (node) {
      if (!node) return
      var refType = String(node.refidty || '').trim()
      var refTypeId = String(node.refidtynm || '').trim()
      if (!this.hasSourceFormIdPermission(refTypeId || refType)) {
        this.handleSourcePermissionDenied()
        return
      }
      this.sourceDialogNode = node
      if (this.isTreeBomSource(refType, refTypeId)) {
        this.treeBomDialogVisible = true
        return
      }
      if (this.isArCheckSource(refType, refTypeId)) {
        this.arCheckDialogVisible = true
        return
      }
      if (this.isPoSource(refType, refTypeId)) {
        this.poDialogVisible = true
        return
      }
      if (this.isOrderAuditSource(refType, refTypeId)) {
        this.orderAuditDialogVisible = true
        return
      }
      if (this.isPcPickSource(refType, refTypeId)) {
        this.pcPickDialogVisible = true
        return
      }
      if (this.isQcPrdSource(refType, refTypeId)) {
        this.qcPrdDialogVisible = true
        return
      }
      if (this.isPrdChkRptSource(refType, refTypeId)) {
        this.prdChkRptDialogVisible = true
        return
      }
      if (this.isSaleReceiveSource(refType, refTypeId)) {
        this.saleReceiveDialogVisible = true
        return
      }
      if (this.isSaleOutSource(refType, refTypeId)) {
        this.saleOutDialogVisible = true
        return
      }
      if (this.isPrdInSource(refType, refTypeId)) {
        this.prdInDialogVisible = true
        return
      }
      if (this.isPrdOutSource(refType, refTypeId)) {
        this.prdOutDialogVisible = true
        return
      }
      if (this.isIncomingQaSource(refType, refTypeId)) {
        this.incomingQaDialogVisible = true
        return
      }
      if (this.isIncomingStkInSource(refType, refTypeId)) {
        this.incomingStkInDialogVisible = true
        return
      }
      if (this.isMaterialPlanSource(refType, refTypeId)) {
        this.materialPlanDialogVisible = true
        return
      }
      this.handleFormDialogError(this.$LANG('1442', '提示') + '：' + this.$LANG('', '该单据类型未配置'))
    },
    /**
     * 展示来源单据弹窗错误。
     */
    handleFormDialogError: function (message) {
      this.showPrompt(message || (this.$LANG('1442', '提示') + '：' + this.$LANG('', '加载失败')))
    },
    /**
     * 来源表单无查看权限时统一提示。
     */
    handleSourcePermissionDenied: function () {
      this.handleFormDialogError(this.$LANG('', '你的账号没有此表单权限，如有需要请联系管理员'))
    },
    /**
     * 关闭所有来源单据详情弹窗并清空当前来源节点。
     */
    closeSourceDialogs: function () {
      this.arCheckDialogVisible = false
      this.poDialogVisible = false
      this.orderAuditDialogVisible = false
      this.pcPickDialogVisible = false
      this.qcPrdDialogVisible = false
      this.prdChkRptDialogVisible = false
      this.saleReceiveDialogVisible = false
      this.saleOutDialogVisible = false
      this.prdInDialogVisible = false
      this.prdOutDialogVisible = false
      this.incomingQaDialogVisible = false
      this.incomingStkInDialogVisible = false
      this.materialPlanDialogVisible = false
      this.treeBomDialogVisible = false
      this.sourceDialogNode = null
    },
    /**
     * 从详情侧栏打开当前节点的来源单据，多个来源时提示用户点标签。
     */
    openCurrentRefDocument: function () {
      if (!this.currentDetailNode || !this.currentDetailNode.refidty) return
      if (this.currentDetailNode.refCount && this.currentDetailNode.refCount > 1) {
        this.handleFormDialogError(this.$LANG('1442', '提示') + '：' + this.$LANG('', '该节点存在多个来源单据，请点击蓝色标签打开对应单据'))
        return
      }
      if (!this.hasSourceFormPermission(this.currentDetailNode.refidty, this.currentDetailNode.nodeData || this.currentDetailNode.raw || {}, 0)) {
        this.handleSourcePermissionDenied()
        return
      }
      this.openSourceDialog(this.currentDetailNode)
    }
  }
}
